"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Contentassignment = function Contentassignment(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ContentassignmentTitle ContentassignmentDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ContentassignmentTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ContentassignmentDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M15.775 22.642c1.866-.269 3.111-1.712 3.453-3.578h-3.453v3.578zm3.421-4.822V9.55l1.245-1.235v10.233a5.4 5.4 0 0 1-5.084 5.387c-.08.052-10.658.052-10.658.052-1.367 0-2.299-1.159-2.299-2.523V3.588c0-1.364.913-2.571 2.277-2.571h12.904l-1.256 1.246H4.673c-.675 0-1.034.646-1.034 1.325v17.88c0 .675.362 1.329 1.04 1.329h9.879v-4.023c0-.333.225-.955.57-.955l.002.001h4.066zM6.952 6.236l4.78.02c.266.002.48.217.48.484l-.001.184a.481.481 0 0 1-.484.48l-4.78-.02a.482.482 0 0 1-.48-.483l.002-.187c0-.266.217-.48.483-.478zm5.615 10.168l-5.62-.025a.481.481 0 0 1-.48-.484l.002-.185a.48.48 0 0 1 .483-.478l5.619.023c.266 0 .481.218.48.482l-.002.187a.48.48 0 0 1-.482.48zM22.8 2.295a.166.166 0 0 0 .002-.235l-.856-.864a.167.167 0 0 0-.235 0l-1.274 1.262 1.096 1.095L22.8 2.295zm-8.44 8.37l6.153-6.101-1.094-1.096-6.149 6.096-.004 1.096 1.094.004zm9.257-9.415c.511.516.507 1.35-.007 1.86l-8.78 8.706-2.717-.013-5.166-.022a.48.48 0 0 1-.48-.482l.002-.187c0-.266.217-.48.483-.478l5.165.02.008-1.57L20.902.38a1.316 1.316 0 0 1 1.86.009l.855.861z",
    fillRule: "evenodd"
  }));
};

Contentassignment.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Contentassignment.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Contentassignment;
exports["default"] = _default;